import { render, staticRenderFns } from "./TextNote.vue?vue&type=template&id=8f92583e&scoped=true&"
import script from "./TextNote.vue?vue&type=script&lang=js&"
export * from "./TextNote.vue?vue&type=script&lang=js&"
import style0 from "./TextNote.vue?vue&type=style&index=0&id=8f92583e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f92583e",
  null
  
)

export default component.exports